


















import { Component, Prop, Vue } from 'vue-property-decorator';
import { ReportBlock } from './ReportBlock';
import { DataType } from '@/core/data/DataType';

import StatVisitors from '../stats/StatVisitors.vue';
import ChartVisitors from '../charts/ChartVisitors.vue';
import TableVisitors from '../tables/TableVisitors.vue';
import TableVisitorsCalendar from '../tables/TableVisitorsCalendar.vue';
import ChartVisitorsByWeekdays from '../charts/ChartVisitorsByWeekdays.vue';

import { FView } from '@/core/FView';

@ReportBlock('Посещаемость', '<i class="fas fa-users"></i>', [DataType.VisitorsDaily], () => {
    return FView.Get().dataManager.GetDataset(DataType.VisitorsDaily).length > 1
})
@Component ({
  components: {
      StatVisitors,
      ChartVisitors,
      TableVisitors,
      TableVisitorsCalendar,
      ChartVisitorsByWeekdays,
  },
})
export default class extends Vue {
}
